import React from 'react';
import { createOvermindMock } from 'overmind';
import { config, useActions, useAppState, useEffects } from '..';

// this whole HOC is a cludge to pass our hooks to class components until they're rewritten as functional components
export function withOvermind<T>(
  WrappedComponent: React.FunctionComponent<T> | React.ComponentClass<T>,
): React.FunctionComponent<T> {
  const WithOvermind = (props: T) => {
    const overmindState = useAppState();
    const overmindActions = useActions();
    const overmindEffects = useEffects();

    let state: any = overmindState;
    let actions: any = overmindActions;
    let effects: any = overmindEffects;

    if (process.env.NODE_ENV === 'test') {
      // TODO: remove once deprecating enzyme
      const overmind = createOvermindMock(config, {
        api: {
          get(path, data) {
            return Promise.resolve({
              data,
            });
          },
          post(path, data) {
            return Promise.resolve({
              data,
            });
          },
          put(path, data) {
            return Promise.resolve({
              data,
            });
          },
          delete(path, data) {
            return Promise.resolve({
              data,
            });
          },
        },
      });

      state = overmind.state;
      actions = overmind.actions;
      effects = overmind.effects;
    }

    return <WrappedComponent overmind={{ state, actions, effects }} {...props} />;
  };

  WithOvermind.displayName = `withOvermind()`;

  return WithOvermind;
}
